import { Link, useNavigate, useSearch } from "@tanstack/react-router";
import { useState, type FormEvent } from "react";

import { useSession } from "../auth/session";
import { Button, Card, ErrorNote, Field, Input } from "../ui/primitives";

export function LoginPage() {
  const session = useSession();
  const navigate = useNavigate();
  const search = useSearch({ from: "/login" });

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await session.signIn(email, password);
      // Back to whatever they were trying to reach, which the guard recorded.
      await navigate({ to: search.next ?? "/sites" });
    } catch (caught) {
      setError(caught);
    } finally {
      setBusy(false);
    }
  }

  return (
    <main id="main" className="mx-auto flex min-h-dvh max-w-sm flex-col justify-center px-6">
      <h1 className="mb-1 text-xl font-semibold">Bozor Bot</h1>
      <p className="mb-6 text-sm text-muted">Sign in to your dashboard.</p>

      <Card>
        <form onSubmit={submit} className="space-y-4">
          {error != null && <ErrorNote error={error} />}

          <Field label="Email" id="email">
            <Input
              id="email"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </Field>

          <Field label="Password" id="password">
            <Input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </Field>

          <p className="-mt-2 text-right text-sm">
            <Link to="/forgot-password" className="text-brand underline">
              Forgot password?
            </Link>
          </p>

          <Button type="submit" variant="primary" className="w-full" disabled={busy}>
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </Card>

      <p className="mt-4 text-center text-sm text-muted">
        No account?{" "}
        <Link to="/register" className="text-brand underline">
          Create one
        </Link>
      </p>
    </main>
  );
}
